/**
 * Nachrichtentext mit einfachem Markdown (Hans 02.10.2026): Die Umsetzungs-
 * Sitzungen und die Erfassungs-KI schreiben Markdown (## Überschrift,
 * **fett**, Listen, `Code`, Links). Roh dargestellt stand dort „## …“ und
 * „**#60 ✔**“. Kompakt für Sprechblasen: Überschriften als fette Zeile,
 * einfache Zeilenumbrüche bleiben erhalten.
 *
 * Sicherheit: react-markdown rendert kein rohes HTML (ohne rehype-raw), und
 * Links laufen durch den Standard-URL-Filter (kein javascript:). Links
 * öffnen in einem neuen Tab ohne Zugriff auf diese Seite.
 */

import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

export function NachrichtText({ text }: { text: string }) {
  return (
    <div className="min-w-0 break-words leading-relaxed [&_code]:rounded [&_code]:bg-black/10 [&_code]:px-1 [&_code]:font-mono [&_code]:text-[0.85em] dark:[&_code]:bg-white/10">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <p className="mb-1 font-bold">{children}</p>,
          h2: ({ children }) => <p className="mb-1 font-bold">{children}</p>,
          h3: ({ children }) => <p className="mb-1 font-semibold">{children}</p>,
          h4: ({ children }) => <p className="mb-1 font-semibold">{children}</p>,
          p: ({ children }) => <p className="mb-2 whitespace-pre-line last:mb-0">{children}</p>,
          ul: ({ children }) => <ul className="mb-2 list-disc pl-5 last:mb-0">{children}</ul>,
          ol: ({ children }) => <ol className="mb-2 list-decimal pl-5 last:mb-0">{children}</ol>,
          li: ({ children }) => <li className="mb-0.5">{children}</li>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" className="break-all underline">
              {children}
            </a>
          ),
          pre: ({ children }) => (
            <pre className="mb-2 overflow-x-auto rounded-md bg-black/10 p-2 text-[12px] dark:bg-white/10 [&_code]:bg-transparent [&_code]:p-0">
              {children}
            </pre>
          ),
          table: ({ children }) => (
            <div className="mb-2 overflow-x-auto">
              <table className="border-collapse text-[12px]">{children}</table>
            </div>
          ),
          th: ({ children }) => <th className="border-b px-2 py-1 text-left font-semibold">{children}</th>,
          td: ({ children }) => <td className="border-b px-2 py-1 align-top">{children}</td>,
          hr: () => <hr className="my-2 opacity-40" />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}
